module.exports = __webpack_public_path__ + "static/nanobit-bw-1567b907c334eb34e1ff606b8cce82c5.jpg";